export enum ContactUsRequirement {
  invalidDetails = 'invalid-details',
}
